/* @flow */
import React, { PureComponent } from 'react';
import _ from 'lodash';

import placeholderImage from '../../assets/images/protones-placeholder-1.png';

const sizeStyleMap = {
  xs: 16,
  s: 32,
  m: 64,
  l: 128,
  xl: 256,
};

type Props = {
  alt: string,
  size?: 'xs' | 's' | 'm' | 'l' | 'xl',
  src: any,
  style?: any,
};

type State = {
  src: any,
};

class ErrorAwareImage extends PureComponent<Props, State> {
  state = {
    src: this.props.src || placeholderImage,
  };

  componentDidUpdate(prevProps: Props) {
    const { src } = prevProps;
    if (src !== this.props.src) {
      this.setState({ src: this.props.src });
    }
  }

  _handleError = () => {
    this.setState({ src: placeholderImage });
  };

  render() {
    const { size, style, ...restProps } = this.props;
    const sizeStyle = size ? { width: sizeStyleMap[size], objectFit: 'contain' } : {};
    return (
      <img
        {...restProps}
        style={_.merge({}, style, sizeStyle)}
        alt={this.props.alt}
        src={this.state.src}
        onError={this._handleError}
      />
    );
  }
}

export default ErrorAwareImage;
